import { render, staticRenderFns } from "./EodReportClubAggregations.vue?vue&type=template&id=3684ca66&scoped=true&"
import script from "./EodReportClubAggregations.vue?vue&type=script&lang=js&"
export * from "./EodReportClubAggregations.vue?vue&type=script&lang=js&"
import style0 from "./EodReportClubAggregations.vue?vue&type=style&index=0&id=3684ca66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684ca66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VIcon,VRow,VSkeletonLoader,VSpacer})
